import React from 'react';
import withWidth from '@material-ui/core/withWidth';

function ResponsiveComponent(props) {
    const width = ['xs', 'sm', 'md', 'lg', 'xl'];
    let component = null;
    for (let i = 0; i <= width.indexOf(props.width); i++) {
        if (props[width[i]]) {
            component = props[width[i]]
        }
    }
    if (!component) {
        for (let i = width.indexOf(props.width); i < width.length ; i++) {
            if (props[width[i]]) {
                component = props[width[i]];
                break;
            }
        }
    }

    return component;
}

export default withWidth()(ResponsiveComponent);
